import { RegionsEnum } from "src/common-panel/enums/regions-enum";

export const environment = {
  name: "Dev",
  production: true,
  development: true,
  region: RegionsEnum.EU,
  redirectUrl: 'https://dev-eu-admin.silentcloudservices.com',
  apiUrl: 'https://dev-global-backend.silentcloudservices.com',
  clientId: '37e8aeda-e363-4923-bbf1-72f9364576ae',
  tenantName: 'f1ed0701-294e-404c-a13b-f81f707f845b',
  sentryEnvironment: "eu-dev",
  sentryTracesSampleRate: 1.0
};
